import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import styles from './QuestionMultiAnswerSlide.css';

function QuestionMultiAnswerSlide({ question, answers, userResponse, submitTemporaryAnswer, id }) {
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (id) {
            setIsPending(false);
        }
    }, [id]);

    const handleChange = (userResponseData, answer) => () => {
        if (isPending) return;

        if (userResponseData.answerIds?.includes(answer.id)) {
            submitTemporaryAnswer({ questionId: id, question, answerIds: userResponseData.answerIds.filter(responseId => responseId !== answer.id) });
        } else {
            submitTemporaryAnswer({ questionId: id, question, answerIds: [...(userResponseData.answerIds || []), answer.id] });
        }
    };

    return (
        <div className={styles.form} key={id}>
            <p className={styles.question}>{question}</p>
            <p className={styles.label}>Select all that apply</p>
            <ul className={styles.answers}>
                {answers.map(answer => {
                    const isChecked = userResponse.answerIds?.length >= 1 ? userResponse.answerIds.includes(answer.id) : false;

                    return (
                        <li key={answer.id} className={styles.answer}>
                            <label className={styles.answerLabel}>
                                <input
                                    type='checkbox'
                                    checked={isChecked}
                                    onChange={handleChange(userResponse, answer)}
                                    className={styles.checkbox}
                                />
                                <span className={styles.answerWrapper}>
                                    {Boolean(answer.imageUrl) && (
                                        <img
                                            alt={answer.text}
                                            src={answer.imageUrl}
                                        />
                                    )}
                                    {answer.text}
                                </span>
                                <span
                                    className={styles.answerIcon}
                                    aria-hidden='true'
                                >
                                    <Icon name='checked' />
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

QuestionMultiAnswerSlide.propTypes = {
    question: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
    userResponse: PropTypes.object
};

QuestionMultiAnswerSlide.defaultProps = {
    userResponse: {}
};

export {
    QuestionMultiAnswerSlide
};
